module.exports = __webpack_public_path__ + "media/application/images/icons/data-explorer-e4b797012786c0de2652c41e1da1055e.svg";